import AdminDashboard from "../pages/Admin/AdminDashboard/AdminDashboard";
import UserDeviceDashboard from "../pages/Admin/UserDashboard/UserDeviceDashboard";
import Admin from "../pages/Admin/Area";
import ChipsLogs from "../pages/Admin/Users/ProfileList/ChipsDetail/ChipLogs";
import ProfileList from "../pages/Admin/Users/ProfileList/ProfileList";
import PlacePage from "../pages/Admin/Users/ProfileList/PlacePage/PlacePage";
import RoomPage from "../pages/Admin/Users/ProfileList/RoomPage/RoomPage";
import Users from "../pages/Admin/Users/Users";
import Dashboard from "../pages/Premises/Dashboard";
import Service from "../pages/Premises/Service";
import Settings from "../pages/Premises/Settings";
import SubAdmins from "../pages/Premises/SubAdmins";
import Permissions from "../pages/Premises/SubAdmins/Permissions";
import React from "react";
import StaticOtp from "../pages/Admin/StaticOtp";
import SendNotification from "../pages/Admin/SendNotification";
import SchedulesLogs from "../pages/Admin/SchedulesLogs";
import Master from "../pages/Admin/Master";
import Firmware from "../pages/Admin/Firmware/Firmware";
import DebugDevice from "../pages/Admin/DebugDevice";
import Logs from "../pages/Admin/Logs";
import Feedback from "../pages/Admin/Feedback";
import Backup from "../pages/Admin/Backup";
import DebugDetail from "../pages/Admin/DebugDetail";
import Testing from "../pages/Admin/Testing/Testing";
import TestingDetailsList from "../pages/Admin/Testing/TestingDetailsList";
import TestingDetailsOfDetails from "../pages/Admin/Testing/TestingDetailsOfDetails";
import TestUtilities from "../pages/TestUtilities/TestUtilities";
import RecycleBin from "../pages/Admin/RecycleBin/RecycleBin";
import Polling from "../pages/Admin/Polling/Polling";
import Ota from "../pages/Admin/Ota/Ota";
import ProductionInventory from "../pages/Admin/Production/ProductionInventory";
import MigrateStatus from "../pages/Admin/Ota/MigrateStatus";

const adminRoutes = [
    { path: "/premises", component: <Dashboard /> },
    { path: "/admins", component: <SubAdmins /> },
    { path: "/service-person", component: <Service /> },
    { path: "/settings", component: <Settings /> },
    { path: "/sub-admins/permissions", component: <Permissions /> },
    { path: "/users", component: <Users /> },
    { path: "/users/profile/:id", component: <ProfileList /> },
    { path: "/users/profile/device/:slaveId", component: <ChipsLogs /> },
    { path: "/users/profile/:userId/places/:placeId/overview", component: <PlacePage /> },
    { path: "/users/profile/:userId/places/:placeId/modules", component: <PlacePage /> },
    { path: "/users/profile/:userId/places/:placeId/appliances", component: <PlacePage /> },
    { path: "/users/profile/:userId/places/:placeId/manual-controls", component: <PlacePage /> },
    { path: "/users/profile/:userId/places/:placeId/users", component: <PlacePage /> },
    { path: "/users/profile/:userId/places/:placeId/logs", component: <PlacePage /> },
    { path: "/users/profile/:userId/places/:placeId/health", component: <PlacePage /> },
    { path: "/users/profile/:userId/places/:placeId/network-management", component: <PlacePage /> },
    { path: "/users/profile/:userId/places/:placeId/rooms/:roomId", component: <RoomPage /> },
    { path: "/area", component: <Admin /> },
    { path: "/dashboard/request-dashboard", component: <AdminDashboard /> },
    { path: "/dashboard/request-dashboard/device-dashboard", component: <UserDeviceDashboard /> },
    { path: "/static-otp", component: <StaticOtp /> },
    { path: "/send-notification", component: <SendNotification /> },
    { path: "/firmware", component: <Firmware /> },
    { path: "/schedules-logs", component: <SchedulesLogs /> },
    { path: "/master", component: <Master /> },
    { path: "/debug-device", component: <DebugDevice /> },
    { path: "/debug-device-details/:macAddress", component: <DebugDetail /> },
    { path: "/logs", component: <Logs /> },
    { path: "/feedback", component: <Feedback /> },
    { path: "/backup", component: <Backup /> },
    { path: "/testing", component: <Testing /> },
    { path: "/testing/details-of-testing/:id", component: <TestingDetailsList /> },
    { path: "/testing/testing-details-of-details/:id", component: <TestingDetailsOfDetails /> },
    { path: "/test-utilities", component: <TestUtilities /> },
    { path: "/recycle-bin", component: <RecycleBin /> },
    { path: "/polling", component: <Polling /> },
    { path: "/ota", component: <Ota /> },
    { path: "/production-inventory", component: <ProductionInventory /> },
    { path: "/migrate-status", component: <MigrateStatus /> },
];

export { adminRoutes };